module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-options.js
// module id = 809
// module chunks = 35783957827783 76758144387212 112643250470497